import { useState, useEffect } from 'react';
import { FaFacebookF, FaInstagram, FaArrowUp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { BsTwitterX } from 'react-icons/bs';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-b from-slate-900 via-gray-900 to-black text-gray-200 pt-16 pb-8 overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#DC2626] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-600 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-6 md:px-20">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Logo & Company Info Section */}
          <div className="flex flex-col lg:col-span-1">
            <div className="flex items-center mb-4">
              <div className="bg-gradient-to-br from-[#DC2626] to-[#B91C1C] w-14 h-14 rounded-xl flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-lg">GIGA</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              The modern way to own your dream car. Providing seamless automotive services across Africa.
            </p>
            {/* Contact Info */}
            <div className="flex flex-col gap-3 mt-4">
              <div className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <FaPhone className="w-4 h-4 text-[#DC2626]" />
                <span className="text-sm">+234 (0) 123 456 7890</span>
              </div>
              <div className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors">
                <FaEnvelope className="w-4 h-4 text-[#DC2626]" />
                <span className="text-sm">info@gigaautos.com</span>
              </div>
              <div className="flex items-start gap-3 text-gray-400">
                <FaMapMarkerAlt className="w-4 h-4 text-[#DC2626] mt-1" />
                <span className="text-sm">Lagos, Nigeria</span>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div className="flex flex-col">
            <h3 className="font-semibold text-white text-lg mb-6">Company</h3>
            <div className="flex flex-col gap-3">
              <Link to="/blog/66c6eeef6fd2b5788b909128" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                About Us
              </Link>
              <Link to="/blog/66c6f093dc2c7f86bdc18469" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Contact Us
              </Link>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Our Team
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Careers
              </a>
              <Link to="/blog" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Blog
              </Link>
            </div>
          </div>

          {/* Services/Experience Links */}
          <div className="flex flex-col">
            <h3 className="font-semibold text-white text-lg mb-6">Services</h3>
            <div className="flex flex-col gap-3">
              <Link to="/cars" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Browse Cars
              </Link>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Car Financing
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Vehicle Insurance
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Trade-In Program
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Maintenance
              </a>
            </div>
          </div>

          {/* Legal & Support Links */}
          <div className="flex flex-col">
            <h3 className="font-semibold text-white text-lg mb-6">Support & Legal</h3>
            <div className="flex flex-col gap-3">
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                FAQs
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Customer Support
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Terms & Conditions
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DC2626] transition-colors text-sm flex items-center gap-2 group">
                <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                Cookie Policy
              </a>
            </div>
          </div>
        </div>

        {/* Social Media & Certification Section */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Social Media Icons */}
            <div className="flex flex-col md:flex-row items-center gap-6">
              <h3 className="text-white font-semibold text-sm">Follow Us:</h3>
              <div className="flex items-center gap-4">
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-800 hover:bg-[#1877F2] rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-[#1877F2]/50" 
                  aria-label="Facebook"
                >
                  <FaFacebookF className="w-5 h-5 text-gray-400 hover:text-white transition-colors" />
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-800 hover:bg-black rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg" 
                  aria-label="Twitter/X"
                >
                  <BsTwitterX className="w-5 h-5 text-gray-400 hover:text-white transition-colors" />
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-800 hover:bg-gradient-to-r hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#833AB4] rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg" 
                  aria-label="Instagram"
                >
                  <FaInstagram className="w-5 h-5 text-gray-400 hover:text-white transition-colors" />
                </a>
              </div>
            </div>

            {/* Certification Badge */}
            <div className="flex items-center gap-2 bg-gray-800/50 backdrop-blur-sm px-4 py-2.5 rounded-lg border border-gray-700 hover:border-blue-500 transition-colors">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600 rounded flex items-center justify-center">
                <span className="text-white font-bold text-xs">ISO</span>
              </div>
              <span className="text-sm font-medium text-gray-300">Licensed & Certified</span>
            </div>
          </div>
        </div>

        {/* Bottom Copyright Section */}
        <div className="border-t border-gray-800 pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-gray-400 text-sm">
              © {currentYear} <span className="text-white font-semibold">Alphanumber Inc. USA. & Nigeria</span>. All rights reserved.
            </div>
            <div className="flex items-center gap-4 text-gray-400 text-sm">
              <span>Made with</span>
              <span className="text-[#DC2626] animate-pulse">♥</span>
              <span>in Africa</span>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-14 h-14 bg-gradient-to-br from-[#DC2626] to-[#B91C1C] hover:from-[#B91C1C] hover:to-[#991B1B] text-white rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 hover:scale-110 z-50 group"
          aria-label="Scroll to top"
        >
          <FaArrowUp className="w-5 h-5 group-hover:-translate-y-1 transition-transform" />
        </button>
      )}
    </footer>
  );
};

export default Footer;
